/**
 * The phone app's push notices: the Firebase key they are sent with, and a test
 * notice to the caller's own phones. The phones register themselves from the app.
 */
import { api } from "./api";

export interface PushSettings {
  keySet: boolean;
  projectId: string;
  clientEmail: string;
}

export const getPushSettings = () => api.get<PushSettings>("/admin/crm/push/settings");

/** `null` removes the key. The server refuses text that is not a service account file. */
export const savePushKey = (serviceAccount: string | null) => api.put<PushSettings>("/admin/crm/push/settings", { serviceAccount });

export const sendTestPush = (title: string, body: string) =>
  api.post<{ devices: number; sent: number }>("/admin/crm/push/test", { title, body });
